import * as Yup from 'yup'

export const initialValues = {
    firstName: '',
    lastName: '',
    phone_country_id: '+1',
    phone: '',
    email: '',
    primary_location: '',
    password: '',
    password_confirmation: '',
    emailNotifications: true,
    textNotifications: false,
}

export const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    phone: Yup.string()
        .matches(
            /\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}/g,
            'Phone number is not valid',
        )
        .required('Phone is required'),
    email: Yup.string()
        .email('Email is not valid')
        .required('Email is required'),
    primary_location: Yup.string().required('Primary Location is required'),
    password: Yup.string()
        .required('Password is required')
        .min(6, 'Password minimum is 6 characters')
        .matches(/[a-zA-Z][0-9]/, 'Password must contain letters and numbers.'),
    password_confirmation: Yup.string()
        .required('Password confirmation is required')
        .oneOf([Yup.ref('password')], 'Your passwords do not match.'),
    emailNotifications: Yup.bool(),
    textNotifications: Yup.bool(),
})
